<script>

    import {replace} from 'svelte-spa-router'
    import Header from './Header.svelte';

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    export let params = {}

    let result = null;

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
	}
	let mebot_id = getCookie('m_id');

    let page_id = params.id
    let page_url = null;

    if (page_id > 0) {
        getLink(page_id);
    }

	async function getLink(id) {

        console.log('page_id: ' + id)

        const res = await fetch(
            "https://api.forever.today/?method=get_page_link",
            {
                method: "POST",
                body: JSON.stringify({
                    dash_token,
                    page_id: id
                }),
            }
        );

        const json = await res.json();
        result = json;
        page_url = json.data.page_link_url;

        console.log('link: ' + page_url)

        replace(page_url);
    }

</script>

<Header
    header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>

<center>
    {#if page_url != null}
    <div style="width: 100%; overflow: hidden;">
        <iframe title="iframe" src="{ page_url }" width="100%" height="800"
            scrolling="yes" style="width: 100%; height: 800px; border:none;"
            allowtransparency="true">
            Mebot content            
        </iframe>
    </div>
    {/if}
</center>

<style>

</style>